import React from "react";
import { FiBookmark } from "react-icons/fi";

interface Props {
  text: string;
  color: string;
}

const ScheduleFlag = ({ text, color }: Props) => (
  <div>
    <FiBookmark />
    <span>{text}</span>
    <style jsx>{`
      div {
        color: ${color};
        font-weight: bold;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 0.9rem;
        padding: 0 10px 0 0;
      }
      span {
        padding: 0 0 0 5px;
      }
    `}</style>
  </div>
);

export default ScheduleFlag;
